import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Users = lazy(() => import('./users/users.component'));
const Groups = lazy(() => import('./groups/groups.component'));
const Certificates = lazy(() => import('./certificates/certificates.component').then((module) => ({ default: module.Certificates })));
const Invites = lazy(() => import('./invites/invites.component').then((module) => ({ default: module.Invites })));

export function ApplicationManageUsersRoutes() {
    return (
        <Route path='users'>
            <Route
                path='users'
                element={<Users />}
            />
            <Route
                path='groups'
                element={<Groups />}
            />
            <Route
                path='certificates'
                element={<Certificates />}
            />
            <Route
                path='invites'
                element={<Invites />}
            />
        </Route>
    );
}
